import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.css';

/**
 * Modal con React Portal — siempre se renderiza en document.body,
 * evitando quedar atrapado en el stacking context de cards o dashboards.
 */
export default function Modal({ children, onClose, maxWidth = 560 }) {
  // Bloquear scroll del body mientras el modal está abierto
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return createPortal(
    <div
      className={`modal-overlay ${styles.capa}`}
      onClick={onClose}
    >
      <div
        className={`modal ${styles.caja}`}
        style={{ '--ancho-max': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth }}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}